import type { Template } from "@/types";

export const PO_04_H2_V2: Template[] = [
{
    id: "po-04-h2v2-01",
    name: "PO 01 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 12, y: 285, width: 168, height: 284, rotation: 0, imageRotation: 0 },
            { id: "2", x: 188, y: 285, width: 377, height: 284, rotation: 0, imageRotation: 0 },
            { id: "3", x: 573, y: 285, width: 376, height: 284, rotation: 0, imageRotation: 0 },
            { id: "4", x: 957, y: 285, width: 168, height: 284, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-04-h2v2-02",
    name: "PO 02 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 99, y: 115, width: 370, height: 627, rotation: 0, imageRotation: 0 },
        { id: "2", x: 603, y: 115, width: 498, height: 347, rotation: 0, imageRotation: 0 },
        { id: "3", x: 603, y: 469, width: 160, height: 271, rotation: 0, imageRotation: 0 },
        { id: "4", x: 771, y: 469, width: 330, height: 271, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h2v2-03",
    name: "PO 03 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 0, width: 568, height: 854, rotation: 0, imageRotation: 0 },
        { id: "2", x: 642, y: 160, width: 419, height: 293, rotation: 0, imageRotation: 0 },
        { id: "3", x: 642, y: 461, width: 134, height: 233, rotation: 0, imageRotation: 0 },
        { id: "4", x: 784, y: 461, width: 278, height: 233, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h2v2-04",
    name: "PO 04 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 36, y: 217, width: 247, height: 420, rotation: 0, imageRotation: 0 },
        { id: "2", x: 291, y: 217, width: 247, height: 420, rotation: 0, imageRotation: 0 },
        { id: "3", x: 666, y: 144, width: 372, height: 280, rotation: 0, imageRotation: 0 },
        { id: "4", x: 666, y: 432, width: 372, height: 279, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h2v2-05",
    name: "PO 05 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 12, y: 285, width: 377, height: 284, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 397, y: 285, width: 167, height: 284, rotation: 0, imageRotation: 0 },
        { id: "3", x: 572, y: 285, width: 167, height: 284, rotation: 0, imageRotation: 0 },
        { id: "4", x: 747, y: 285, width: 378, height: 284, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h2v2-06",
    name: "PO 06 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 76, y: 181, width: 649, height: 492, rotation: 0, imageRotation: 0 },
        { id: "2", x: 733, y: 181, width: 327, height: 242, rotation: 0, imageRotation: 0 },
        { id: "3", x: 733, y: 431, width: 160, height: 242, rotation: 0, imageRotation: 0 },
        { id: "4", x: 901, y: 431, width: 159, height: 242, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h2v2-07",
    name: "PO 07 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 71, y: 162, width: 311, height: 530, rotation: 0, imageRotation: 0 },   
        { id: "2", x: 390, y: 162, width: 356, height: 261, rotation: 0, imageRotation: 0 },
        { id: "3", x: 390, y: 431, width: 356, height: 261, rotation: 0, imageRotation: 0 },
        { id: "4", x: 754, y: 162, width: 311, height: 530, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h2v2-08",
    name: "PO 08 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 71, y: 162, width: 310, height: 530, rotation: 0, imageRotation: 0 },
        { id: "2", x: 389, y: 162, width: 309, height: 530, rotation: 0, imageRotation: 0 },
        { id: "3", x: 706, y: 162, width: 360, height: 261, rotation: 0, imageRotation: 0 },
        { id: "4", x: 706, y: 431, width: 360, height: 261, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h2v2-09",
    name: "PO 09 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 238, y: 86, width: 453, height: 337, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 238, y: 431, width: 200, height: 337, rotation: 0, imageRotation: 0 },
        { id: "3", x: 446, y: 431, width: 452, height: 337, rotation: 0, imageRotation: 0 },
        { id: "4", x: 699, y: 86, width: 200, height: 337, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h2v2-10",
    name: "PO 10 - H2V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h2_v2_10.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 55, y: 165, width: 337, height: 257, rotation: 0, imageRotation: 0 },
        { id: "2", x: 55, y: 430, width: 165, height: 257, rotation: 0, imageRotation: 0 },
        { id: "3", x: 228, y: 430, width: 164, height: 257, rotation: 0, imageRotation: 0 },
        { id: "4", x: 400, y: 165, width: 680, height: 522, rotation: 0, imageRotation: 0 }
    ],
}
];